import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

// Import components
import { AuthProvider, withAuth } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import GlobalUploadStatus from './components/GlobalUploadStatus';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ToursManagement from './pages/ToursManagement';
import TravelersManagement from './pages/TravelersManagement';
import BulkDocumentUpload from './pages/BulkDocumentUpload';
import Settings from './pages/Settings';
import TravelerProfile from './pages/TravelerProfile';

// Protected components
const ProtectedAdminDashboard = withAuth(AdminDashboard);
const ProtectedToursManagement = withAuth(ToursManagement);
const ProtectedTravelersManagement = withAuth(TravelersManagement);
const ProtectedBulkDocumentUpload = withAuth(BulkDocumentUpload);
const ProtectedSettings = withAuth(Settings);

function App() {
  return (
    <CustomThemeProvider>
      <AuthProvider>
        <Router>
          <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
            <Routes>
              {/* Public Routes */}
              {/* QR Code access route - mobile optimized */}
              <Route path="/traveler/:uuid" element={<TravelerProfile />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedAdminDashboard />} />
              <Route path="/admin/tours" element={<ProtectedToursManagement />} />
              <Route path="/admin/travelers" element={<ProtectedTravelersManagement />} />
              <Route path="/admin/bulk-upload" element={<ProtectedBulkDocumentUpload />} />
              <Route path="/admin/settings" element={<ProtectedSettings />} />
              
              {/* Default redirects */}
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="/" element={<Navigate to="/admin/login" replace />} />
              
              {/* 404 handler */}
              <Route path="*" element={
                <Box p={3} textAlign="center">
                  <h1>404 - Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                </Box>
              } />
            </Routes>
            <GlobalUploadStatus />
          </Box>
        </Router>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;